// extracted by mini-css-extract-plugin
module.exports = {"about":"about_about__1ZTYS","intro":"about_intro__1teit","story":"about_story__3qyRN","story__images":"about_story__images__3Uzbv","story__info":"about_story__info__2VhjB"};